import Provider from "./Provider-Api";
import CheckApi from "./check-api";


export const bookingGetBooking = async (data, token) => {
    CheckApi('getBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBooking",
        data,
        token
    });
    CheckApi('dataRes-getBooking', dataRes)
    return dataRes;
};

export const bookingGetOrganizationHistoryBooking = async (data, token) => {
    CheckApi('getOrganizationHistoryBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getOrganizationHistoryBooking",
        data,
        token
    });
    CheckApi('dataRes-getOrganizationHistoryBooking', dataRes)
    return dataRes;
};

export const bookingGetBookingTopbar = async (data, token) => {
    CheckApi('getBookingTopbar', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingTopbar",
        data,
        token
    });
    CheckApi('dataRes-getBookingTopbar', dataRes)
    return dataRes;
};

export const bookingGetBookingbyDateANDtypeDate = async (data, token) => {
    CheckApi('getBookingbyDateANDtypeDate', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingbyDateANDtypeDate",
        data,
        token
    });
    CheckApi('dataRes-getBookingbyDateANDtypeDate', dataRes)
    return dataRes;
};

export const bookingAddBooking = async (data, token) => {
    CheckApi('addBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addBooking",
        data,
        token
    });
    CheckApi('dataRes-addBooking', dataRes)
    return dataRes;
};

export const bookingUpdateBooking = async (data, token) => {
    CheckApi('updateBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBooking",
        data,
        token
    });
    CheckApi('dataRes-updateBooking', dataRes)
    return dataRes;
};

export const bookingUpdateBookingANDresetPaymentBooking = async (data, token) => {
    CheckApi('updateBookingANDresetPaymentBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBookingANDresetPaymentBooking",
        data,
        token
    });
    CheckApi('dataRes-updateBookingANDresetPaymentBooking', dataRes)
    return dataRes;
};

export const bookingUpdateBookingPaymentANDBill = async (data, token) => {
    CheckApi('updateBookingPaymentANDBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBookingPaymentANDBill",
        data,
        token
    });
    CheckApi('dataRes-updateBookingPaymentANDBill', dataRes)
    return dataRes;
};

export const bookingUpdateBookingStatus = async (data, token) => {
    CheckApi('updateBookingStatus', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBookingStatus",
        data,
        token
    });
    CheckApi('dataRes-updateBookingStatus', dataRes)
    return dataRes;
};

export const bookingGetBookingCustomer = async (data, token) => {
    CheckApi('getBookingCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingCustomer",
        data,
        token
    });
    CheckApi('dataRes-getBookingCustomer', dataRes)
    return dataRes;
};

export const bookingGetCustomerHistoryBooking = async (data, token) => {
    CheckApi('getCustomerHistoryBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getCustomerHistoryBooking",
        data,
        token
    });
    CheckApi('dataRes-getCustomerHistoryBooking', dataRes)
    return dataRes;
};

export const bookingGetCustomerHistoryTreatmentBooking = async (data, token) => {
    CheckApi('getCustomerHistoryTreatmentBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getCustomerHistoryTreatmentBooking",
        data,
        token
    });
    CheckApi('dataRes-getCustomerHistoryTreatmentBooking', dataRes)
    return dataRes;
};

export const bookingAddBookingCustomer = async (data, token) => {
    CheckApi('addBookingCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addBookingCustomer",
        data,
        token
    });
    CheckApi('dataRes-addBookingCustomer', dataRes)
    return dataRes;
};

export const bookingUpdateBookingCustomer = async (data, token) => {
    CheckApi('updateBookingCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBookingCustomer",
        data,
        token
    });
    CheckApi('dataRes-updateBookingCustomer', dataRes)
    return dataRes;
};

export const bookingDeleteBookingCustomer = async (item, token) => {
    CheckApi('deleteBookingCustomer', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/deleteBookingCustomer",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteBookingCustomer', dataRes)
    return dataRes;
};

export const bookingGetCheckBookingTreatmentUsedByTime = async (data, token) => {
    CheckApi('getCheckBookingTreatmentUsedByTime', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getCheckBookingTreatmentUsedByTime",
        data,
        token
    });
    CheckApi('dataRes-getCheckBookingTreatmentUsedByTime', dataRes)
    return dataRes;
};

export const bookingGetCheckBookingTreatmentUsedByTimeInHousekeeping = async (data, token) => {
    CheckApi('getCheckBookingTreatmentUsedByTimeInHousekeeping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getCheckBookingTreatmentUsedByTimeInHousekeeping",
        data,
        token
    });
    CheckApi('dataRes-getCheckBookingTreatmentUsedByTimeInHousekeeping', dataRes)
    return dataRes;
};

export const bookingGetBookingCustomerTreatment = async (data, token) => {
    CheckApi('getBookingCustomerTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingCustomerTreatment",
        data,
        token
    });
    CheckApi('dataRes-getBookingCustomerTreatment', dataRes)
    return dataRes;
};

export const bookingGetBookingCustomerTreatmentByDateHousekeeping = async (data, token) => {
    CheckApi('getBookingCustomerTreatmentByDateHousekeeping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingCustomerTreatmentByDateHousekeeping",
        data,
        token
    });
    CheckApi('dataRes-getBookingCustomerTreatmentByDateHousekeeping', dataRes)
    return dataRes;
};

export const bookingGetBookingCustomerTreatmentByBetweenDateHousekeepingg = async (data, token) => {
    CheckApi('getBookingCustomerTreatmentByBetweenDateHousekeeping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingCustomerTreatmentByBetweenDateHousekeeping",
        data,
        token
    });
    CheckApi('dataRes-getBookingCustomerTreatmentByBetweenDateHousekeeping', dataRes)
    return dataRes;
};

export const bookingAddBookingCustomerTreatment = async (data, token) => {
    CheckApi('addBookingCustomerTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addBookingCustomerTreatment",
        data,
        token
    });
    CheckApi('dataRes-addBookingCustomerTreatment', dataRes)
    return dataRes;
};

export const bookingUpdateBookingCustomerTreatment = async (data, token) => {
    CheckApi('updateBookingCustomerTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBookingCustomerTreatment",
        data,
        token
    });
    CheckApi('dataRes-updateBookingCustomerTreatment', dataRes)
    return dataRes;
};

export const bookingGetPaymentCustomerBill = async (data, token) => {
    CheckApi('getPaymentCustomerBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getPaymentCustomerBill",
        data,
        token
    });
    CheckApi('dataRes-getPaymentCustomerBill', dataRes)
    return dataRes;
};

export const bookingAddPaymentCustomerBill = async (data, token) => {
    CheckApi('addPaymentCustomerBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addPaymentCustomerBill",
        data,
        token
    });
    CheckApi('dataRes-addPaymentCustomerBill', dataRes)
    return dataRes;
};

export const bookingGetCustomerCouponCodeByPaymentCouponBill = async (data, token) => {
    CheckApi('getPaymentCustomerBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getCustomerCouponCodeByPaymentCouponBill",
        data,
        token
    });
    CheckApi('dataRes-getCustomerCouponCodeByPaymentCouponBill', dataRes)
    return dataRes;
};

export const bookingAddPaymentCouponBill = async (data, token) => {
    CheckApi('addPaymentCouponBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addPaymentCouponBill",
        data,
        token
    });
    CheckApi('dataRes-addPaymentCouponBill', dataRes)
    return dataRes;
};

export const bookingUpdateBookingCustomerTreatmentChangeStatusHousekeeping = async (data, token) => {
    CheckApi('updateBookingCustomerTreatmentChangeStatusHousekeeping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBookingCustomerTreatmentChangeStatusHousekeeping",
        data,
        token
    });
    CheckApi('dataRes-updateBookingCustomerTreatmentChangeStatusHousekeeping', dataRes)
    return dataRes;
};

export const bookingDeleteBookingCustomerTreatmentByBookingCustomer = async (item, token) => {
    CheckApi('deleteBookingCustomer', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/deleteBookingCustomerTreatmentByBookingCustomer",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteBookingCustomerTreatmentByBookingCustomer', dataRes)
    return dataRes;
};

export const bookingDeleteBookingCustomerTreatment = async (item, token) => {
    CheckApi('deleteBookingCustomerTreatment', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/deleteBookingCustomerTreatment",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteBookingCustomerTreatment', dataRes)
    return dataRes;
};

// export const bookingUpdateBookCustomerdetail = async (data, token) => {
//     CheckApi('updateBookCustomerdetail', data, token)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/booking/updateBookCustomerdetail",
//         data,
//         token
//     });
//     CheckApi('dataRes-updateBookCustomerdetail', dataRes)
//     return dataRes;
// };

// export const bookingDeleteBookCustomerdetail = async (item, token) => {
//     CheckApi('deleteBookCustomerdetail', item)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/booking/deleteBookCustomerdetail",
//         data: {
//             item
//         },
//         token
//     });
//     CheckApi('dataRes-deleteBookCustomerdetail', dataRes)
//     return dataRes;
// };

// export const bookingGetBookSpadetail = async (data, token) => {
//     CheckApi('getBookSpadetail', data, token)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/booking/getBookSpadetail",
//         data,
//         token
//     });
//     CheckApi('dataRes-getBookSpadetail', dataRes)
//     return dataRes;
// };

// export const bookingAddBookSpadetail = async (data, token) => {
//     CheckApi('addBookSpadetail', data, token)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/booking/addBookSpadetail",
//         data,
//         token
//     });
//     CheckApi('dataRes-addBookSpadetail', dataRes)
//     return dataRes;
// };

// export const bookingUpdateBookSpadetail = async (data, token) => {
//     CheckApi('updateBookSpadetail', data, token)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/booking/updateBookSpadetail",
//         data,
//         token
//     });
//     CheckApi('dataRes-updateBookSpadetail', dataRes)
//     return dataRes;
// };

// export const bookingDeleteBookSpadetail = async (item, token) => {
//     CheckApi('deleteBookSpadetail', item)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/booking/deleteBookSpadetail",
//         data: {
//             item
//         },
//         token
//     });
//     CheckApi('dataRes-deleteBookSpadetail', dataRes)
//     return dataRes;
// };

export const bookingGetPaymentBooking = async (data, token) => {
    CheckApi('getPaymentBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getPaymentBooking",
        data,
        token
    });
    CheckApi('dataRes-getPaymentBooking', dataRes)
    return dataRes;
};

export const bookingGetPaymentBookingbySpa = async (data, token) => {
    CheckApi('getPaymentBookingbySpa', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getPaymentBookingbySpa",
        data,
        token
    });
    CheckApi('dataRes-getPaymentBookingbySpa', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBooking = async (data, token) => {
    CheckApi('updatePaymentBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBooking",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBooking', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingPromotion = async (data, token) => {
    CheckApi('updatePaymentBookingPromotion', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingPromotion",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingPromotion', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingCoupon = async (data, token) => {
    CheckApi('updatePaymentBookingPromotion', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingCoupon",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingCoupon', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingWithBookingStatus = async (data, token) => {
    CheckApi('updatePaymentBookingWithBookingStatus', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingWithBookingStatus",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingWithBookingStatus', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingIncludeVat = async (data, token) => {
    CheckApi('updatePaymentBookingIncludeVat', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingIncludeVat",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingIncludeVat', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingTotal = async (data, token) => {
    CheckApi('updatePaymentBookingTotal', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingTotal",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingTotal', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingEditPromotion = async (data, token) => {
    CheckApi('updatePaymentBookingEditPromotion', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingEditPromotion",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingEditPromotion', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingRefund = async (data, token) => {
    CheckApi('updatePaymentBookingRefund', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingRefund",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingRefund', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingAddon = async (data, token) => {
    CheckApi('updatePaymentBookingAddon', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingAddon",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingAddon', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingBuyerDetail = async (data, token) => {
    CheckApi('updatePaymentBookingBuyerDetail', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingBuyerDetail",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingBuyerDetail', dataRes)
    return dataRes;
};

export const bookingGetPaymentBill = async (data, token) => {
    CheckApi('getPaymentBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getPaymentBill",
        data,
        token
    });
    CheckApi('dataRes-getPaymentBill', dataRes)
    return dataRes;
};

export const bookingAddPaymentBill = async (data, token) => {
    CheckApi('addPaymentBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addPaymentBill",
        data,
        token
    });
    CheckApi('dataRes-addPaymentBill', dataRes)
    return dataRes;
};

export const bookingGetPaymentBuyerDetail = async (data, token) => {
    CheckApi('getPaymentBuyerDetail', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getPaymentBuyerDetail",
        data,
        token
    });
    CheckApi('dataRes-getPaymentBuyerDetail', dataRes)
    return dataRes;
};

export const bookingGetPaymentAllBuyerDetail = async (data, token) => {
    CheckApi('getPaymentAllBuyerDetail', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getPaymentAllBuyerDetail",
        data,
        token
    });
    CheckApi('dataRes-getPaymentAllBuyerDetail', dataRes)
    return dataRes;
};

export const bookingAddPaymentBuyerDetail = async (data, token) => {
    CheckApi('addPaymentBuyerDetail', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addPaymentBuyerDetail",
        data,
        token
    });
    CheckApi('dataRes-addPaymentBuyerDetail', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBuyerDetail = async (data, token) => {
    CheckApi('updatePaymentBuyerDetail', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBuyerDetail",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBuyerDetail', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBookingWithEditBooking = async (data, token) => {
    CheckApi('updatePaymentBookingWithEditBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBookingWithEditBooking",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBookingWithEditBooking', dataRes)
    return dataRes;
};

export const bookingUpdatePaymentBillWithEditBooking = async (data, token) => {
    CheckApi('updatePaymentBillWithEditBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updatePaymentBillWithEditBooking",
        data,
        token
    });
    CheckApi('dataRes-updatePaymentBillWithEditBooking', dataRes)
    return dataRes;
};

export const bookingGetPaymentDataBill = async (data, token) => {
    CheckApi('getPaymentDataBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getPaymentDataBill",
        data,
        token
    });
    CheckApi('dataRes-getPaymentDataBill', dataRes)
    return dataRes;
};

export const bookingAddPaymentDataBill = async (data, token) => {
    CheckApi('addPaymentDataBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addPaymentDataBill",
        data,
        token
    });
    CheckApi('dataRes-addPaymentDataBill', dataRes)
    return dataRes;
};

export const bookingGetPaymentTableBill = async (data, token) => {
    CheckApi('getPaymentTableBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getPaymentTableBill",
        data,
        token
    });
    CheckApi('dataRes-getPaymentTableBill', dataRes)
    return dataRes;
};

export const bookingAddPaymentTableBill = async (data, token) => {
    CheckApi('addPaymentTableBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addPaymentTableBill",
        data,
        token
    });
    CheckApi('dataRes-addPaymentTableBill', dataRes)
    return dataRes;
};

export const bookingGetRefundDataBill = async (data, token) => {
    CheckApi('getRefundDataBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getRefundDataBill",
        data,
        token
    });
    CheckApi('dataRes-getRefundDataBill', dataRes)
    return dataRes;
};

export const bookingAddRefundDataBill = async (data, token) => {
    CheckApi('addRefundDataBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addRefundDataBill",
        data,
        token
    });
    CheckApi('dataRes-addRefundDataBill', dataRes)
    return dataRes;
};

export const bookingGetRefundTableBill = async (data, token) => {
    CheckApi('getRefundTableBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getRefundTableBill",
        data,
        token
    });
    CheckApi('dataRes-getRefundTableBill', dataRes)
    return dataRes;
};

export const bookingAddRefundTableBill = async (data, token) => {
    CheckApi('addRefundTableBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addRefundTableBill",
        data,
        token
    });
    CheckApi('dataRes-addRefundTableBill', dataRes)
    return dataRes;
};

export const bookingGetRefundBill = async (data, token) => {
    CheckApi('getRefundBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getRefundBill",
        data,
        token
    });
    CheckApi('dataRes-getRefundBill', dataRes)
    return dataRes;
};

export const bookingAddRefundBill = async (data, token) => {
    CheckApi('addRefundBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addRefundBill",
        data,
        token
    });
    CheckApi('dataRes-addRefundBill', dataRes)
    return dataRes;
};

export const bookingGetAddonBill = async (data, token) => {
    CheckApi('getAddonBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getAddonBill",
        data,
        token
    });
    CheckApi('dataRes-getAddonBill', dataRes)
    return dataRes;
};

export const bookingAddAddonBill = async (data, token) => {
    CheckApi('addAddonBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addAddonBill",
        data,
        token
    });
    CheckApi('dataRes-addAddonBill', dataRes)
    return dataRes;
};

export const bookingGetBookingAddonPlusDataBill = async (data, token) => {
    CheckApi('getBookingAddonPlusDataBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingAddonPlusDataBill",
        data,
        token
    });
    CheckApi('dataRes-getBookingAddonPlusDataBill', dataRes)
    return dataRes;
};

export const bookingAddBookingAddonPlusDataBill = async (data, token) => {
    CheckApi('addBookingAddonPlusDataBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addBookingAddonPlusDataBill",
        data,
        token
    });
    CheckApi('dataRes-addBookingAddonPlusDataBill', dataRes)
    return dataRes;
};

export const bookingGetBookingAddonPlusTableBill = async (data, token) => {
    CheckApi('getBookingAddonPlusTableBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingAddonPlusTableBill",
        data,
        token
    });
    CheckApi('dataRes-getBookingAddonPlusTableBill', dataRes)
    return dataRes;
};

export const bookingAddBookingAddonPlusTableBill = async (data, token) => {
    CheckApi('addBookingAddonPlusTableBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addBookingAddonPlusTableBill",
        data,
        token
    });
    CheckApi('dataRes-addBookingAddonPlusTableBill', dataRes)
    return dataRes;
};

export const bookingUpdateBookingAddonPlusTableBill = async (data, token) => {
    CheckApi('updateBookingAddonPlusTableBill', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBookingAddonPlusTableBill",
        data,
        token
    });
    CheckApi('dataRes-updateBookingAddonPlusTableBill', dataRes)
    return dataRes;
};

export const bookingGetBookingMembership = async (data, token) => {
    CheckApi('getBookingMembership', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingMembership",
        data,
        token
    });
    CheckApi('dataRes-getBookingMembership', dataRes)
    return dataRes;
};

export const bookingGetBookingMembershipTimeLeft = async (data, token) => {
    CheckApi('getBookingMembershipTimeLeft', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingMembershipTimeLeft",
        data,
        token
    });
    CheckApi('dataRes-getBookingMembershipTimeLeft', dataRes)
    return dataRes;
};

export const bookingGetAllInOneCustomerComplimentaryHistory = async (data, token) => {
    CheckApi('getAllInOneCustomerComplimentaryHistory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getAllInOneCustomerComplimentaryHistory",
        data,
        token
    });
    CheckApi('dataRes-getAllInOneCustomerComplimentaryHistory', dataRes)
    return dataRes;
};

export const bookingAddBookingMembership = async (data, token) => {
    CheckApi('addBookingMembership', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addBookingMembership",
        data,
        token
    });
    CheckApi('dataRes-addBookingMembership', dataRes)
    return dataRes;
};

export const bookingDeleteBookingMembership = async (item, token) => {
    CheckApi('deleteBookingMembership', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/deleteBookingMembership",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteBookingMembership', dataRes)
    return dataRes;
};

export const bookingGetBookingTips = async (data, token) => {
    CheckApi('getBookingTips', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingTips",
        data,
        token
    });
    CheckApi('dataRes-getBookingTips', dataRes)
    return dataRes;
};

export const bookingGetBookingTipsTherapist = async (data, token) => {
    CheckApi('getBookingTipsTherapist', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/getBookingTipsTherapist",
        data,
        token
    });
    CheckApi('dataRes-getBookingTipsTherapist', dataRes)
    return dataRes;
};

export const bookingAddBookingTips = async (data, token) => {
    CheckApi('addBookingTips', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/addBookingTips",
        data,
        token
    });
    CheckApi('dataRes-addBookingTips', dataRes)
    return dataRes;
};

export const bookingUpdateBookingTips = async (data, token) => {
    CheckApi('updateBookingTips', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/updateBookingTips",
        data,
        token
    });
    CheckApi('dataRes-updateBookingTips', dataRes)
    return dataRes;
};

export const bookingDeleteBookingTips = async (item, token) => {
    CheckApi('deleteBookingTips', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/booking/deleteBookingTips",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteBookingTips', dataRes)
    return dataRes;
};